import { IReferral } from "../../../Services/Referral";
import { formatReferralWhen, formatUsDate, memberPartyCell } from "../referralFormat";
import { referralStaffDetailLabelClass, referralStaffDetailTableClass, referralStaffDetailValueClass, ReferralTable } from "../referralSurface";

type Props = {
  row: IReferral;
  whenLabel: string;
  byLabel: string;
  toLabel: string;
};

export default function StaffReferralDetailTable({ row, whenLabel, byLabel, toLabel }: Props) {
  return (
    <ReferralTable measureKey={row.id} className={referralStaffDetailTableClass}>
      <tbody>
        <tr>
          <td className={referralStaffDetailLabelClass}>Submission Date:</td>
          <td className={referralStaffDetailValueClass}>{formatUsDate(row.submissionDate)}</td>
          <td className={referralStaffDetailLabelClass}>Submitted By:</td>
          <td className={referralStaffDetailValueClass}>{memberPartyCell("", row.submittedByFirmName)}</td>
        </tr>
        <tr>
          <td className={referralStaffDetailLabelClass}>{whenLabel}:</td>
          <td className={referralStaffDetailValueClass} colSpan={3}>{formatReferralWhen(row)}</td>
        </tr>
        <tr>
          <td className={referralStaffDetailLabelClass}>{byLabel}:</td>
          <td className={referralStaffDetailValueClass}>{memberPartyCell(row.sendByName, row.firmByName)}</td>
          <td className={referralStaffDetailLabelClass}>{toLabel}:</td>
          <td className={referralStaffDetailValueClass}>{memberPartyCell(row.sendToName, row.firmToName)}</td>
        </tr>
        <tr>
          <td className={referralStaffDetailLabelClass}>Type:</td>
          <td className={referralStaffDetailValueClass}>{row.referralType}</td>
          <td className={referralStaffDetailLabelClass}>Estimated Fees:</td>
          <td className={referralStaffDetailValueClass}>{row.showFees === false ? "—" : row.estimatedFeesDetail}</td>
        </tr>
        <tr>
          <td className={referralStaffDetailLabelClass}>Detail:</td>
          <td className={`${referralStaffDetailValueClass} pr-[30px]`} colSpan={3}>{row.detail}</td>
        </tr>
      </tbody>
    </ReferralTable>
  );
}
